
import "../Heading/Heading.st.css.js";
import "../Text/Text.st.css.js";
import "../Foundation/stylable/colors.st.css.js";

import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_178_0_EmptyState";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_178_0_EmptyState__root","imageContainer":"wds_1_178_0_EmptyState__imageContainer","childrenContainer":"wds_1_178_0_EmptyState__childrenContainer","container":"wds_1_178_0_EmptyState__container","imageElement":"wds_1_178_0_EmptyState__imageElement","titleContainer":"wds_1_178_0_EmptyState__titleContainer","title":"wds_1_178_0_EmptyState__title","sectionTitle":"wds_1_178_0_EmptyState__sectionTitle","subtitle":"wds_1_178_0_EmptyState__subtitle","subtitleContainer":"wds_1_178_0_EmptyState__subtitleContainer"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-space-100":"--wds-space-100","wds-space-150":"--wds-space-150","wds-space-400":"--wds-space-400","wds-space-700":"--wds-space-700","wds-color-border-dark-secondary":"--wds-color-border-dark-secondary","wds-empty-state-border-radius":"--wds-empty-state-border-radius","wds-empty-state-page-content-paddings":"--wds-empty-state-page-content-paddings","wds-empty-state-section-content-paddings":"--wds-empty-state-section-content-paddings"}; 




